module.exports = __WEBPACK_EXTERNAL_MODULE__65953__;